export default{
    searchingData: function(state) {
        return {
            per_page: state.per_page,
            page: state.page,
            search: state.search,
            sort: state.sort
        }
    }
}